import { PATHS, TEMPLATES_PATH } from 'routes/routes.constants';

export const PUBLIC_PATHS = [
  PATHS.OPENTABLE_CALLBACK,
  PATHS.OPENTABLE_LOGIN,
  PATHS.OPENTABLE_REGION,
  PATHS.LOGOUT,
  PATHS.PARAGON_OAUTH_REDIRECT,
  TEMPLATES_PATH,
] as const;
